import SphTextarea from './Textarea.vue';

export { SphTextarea };
export default SphTextarea;
